'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Chevron_module = require('./Chevron.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const points = ['10', '1.86321757', '8.10810809', '0', '0', '7.98521826', '8.10810809', '15.9704364', '10', '14.1072189', '3.78378374', '7.98521826'].join(' ');
let Direction = /*#__PURE__*/function (Direction) {
  Direction["Up"] = "up";
  Direction["Down"] = "down";
  Direction["Left"] = "left";
  Direction["Right"] = "right";
  return Direction;
}({});
const transforms = {
  [Direction.Up]: 'translate(8, 4) rotate(90 4 4)',
  [Direction.Down]: 'translate(0, 8) rotate(270 4 4)',
  [Direction.Left]: 'translate(0, 0) rotate(0 4 4)',
  [Direction.Right]: 'translate(4, 8) rotate(180 4 4)'
};
const ChevronIcon = ({
  title = 'Combobox arrow',
  s = {},
  direction = Direction.Left
}) => {
  const {
    iconsPrimaryNone
  } = nthHookTheme.useTheme();
  const style = {
    ...iconsPrimaryNone,
    ...s
  };
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    "aria-labelledby": "nth-bit-icon-chevron-title",
    role: "img",
    className: Chevron_module["default"].container,
    style: {
      fill: s.color,
      ...style
    },
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default["default"].createElement("title", {
    id: "nth-bit-icon-chevron-title"
  }, title), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: points,
    transform: transforms[direction || Direction.Left]
  }));
};
var Chevron = nthHookTheme.withThemeProvider(ChevronIcon, {
  themeTokens: ['iconsPrimaryNone']
});

exports.Direction = Direction;
exports["default"] = Chevron;
